export default {
  API_ENDPOINT: `https://vast-mesa-85867.herokuapp.com/`,
  API_KEY: process.env.REACT_APP_API_KEY
};
